import {fluTaskOutcome} from '../../lib/onboarding/consultant/fluTaskOutcome';
export function FluTaskOutcome({metadata}:{metadata:unknown}){
 const outcome=fluTaskOutcome(metadata);if(!outcome)return null;
 return <section aria-label="Esito dell’attività" className="my-3 rounded-md border border-[#E8E5E0] bg-[#FAF9F6] p-3 dark:border-gray-700 dark:bg-gray-800">
  <h3 className="mb-1 text-xs font-medium text-[#787774] dark:text-gray-400">Esito</h3>
  <p className="whitespace-pre-wrap text-sm leading-relaxed text-[#37352F] dark:text-gray-100">{outcome}</p>
 </section>;
}
